// extracted by mini-css-extract-plugin
export default {"LogosPanel":"LogosPanel_LogosPanel__B1mSB","Image":"LogosPanel_Image__VoF4F"};